var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program-alarm",on:{"click":function($event){$event.preventDefault();return _vm.clickAlarm.apply(null, arguments)}}},[(_vm.isOn)?_c('alarm-on'):_c('alarm-off')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }